import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { UnitType } from 'src/app/models/enums/unit-type.enum';
import { MeasurementService } from 'src/app/services/measurement.service';
import { IStress } from '../../models/stress.model';

@Component({
    selector: 'app-stressfactor',
    templateUrl: './stressfactor.component.html',
    styleUrls: ['./stressfactor.component.scss'],
})
export class StressfactorComponent {
    @Input()
    set istress(data: IStress) {
        if (data) {
            this._istress = data;

            this.setUpValues();
        }
    }
    get istress(): IStress {
        return this._istress;
    }

    valObj = {} as any;
    tooltip_position = 'above';
    private _istress: IStress = {} as IStress;

    constructor(
        private cd: ChangeDetectorRef,
        private meaSvc: MeasurementService
    ) {}

    setUpValues() {
        if (this.istress.Residual_value != undefined || this.istress.Residual_value != null) {
            this.valObj.Residual_value = this.meaSvc.getUserPreferedValue(this.istress.Residual_value, UnitType.DefaultStressUnit);
        }
        if (this.istress.Min2Seal_value != undefined || this.istress.Min2Seal_value != null) {
            this.valObj.Min2Seal_value = this.meaSvc.getUserPreferedValue(this.istress.Min2Seal_value, UnitType.DefaultStressUnit);
        }
        if (this.istress.Max_value != undefined || this.istress.Max_value != null) {
            this.valObj.Max_value = this.meaSvc.getUserPreferedValue(this.istress.Max_value, UnitType.DefaultStressUnit);
        }
        if (this.istress.applied1_value != undefined || this.istress.applied1_value != null) {
            this.valObj.applied1_value = this.meaSvc.getUserPreferedValue(this.istress.applied1_value, UnitType.DefaultStressUnit);
        }
        if (this.istress.applied2_value != undefined || this.istress.applied2_value != null) {
            this.valObj.applied2_value = this.meaSvc.getUserPreferedValue(this.istress.applied2_value, UnitType.DefaultStressUnit);
        }
        if (this.istress.applied3_value != undefined || this.istress.applied3_value != null) {
            this.valObj.applied3_value = this.meaSvc.getUserPreferedValue(this.istress.applied3_value, UnitType.DefaultStressUnit);
        }
        this.cd.detectChanges();
    }
}
